import CodeIcon from "@mui/icons-material/Code";
import StorageIcon from "@mui/icons-material/Storage";
import BrushIcon from "@mui/icons-material/Brush";
import CloudIcon from "@mui/icons-material/Cloud";
import SecurityIcon from "@mui/icons-material/Security";
import SmartphoneIcon from "@mui/icons-material/Smartphone";
import { SvgIconComponent } from "@mui/icons-material";

export interface Skill {
  name: string;
  Icon: SvgIconComponent;
  description: string[];
}

export const skills: Skill[] = [
  {
    name: "Frontend Development",
    Icon: CodeIcon,
    description: [
      "JavaScript",
      "React",
      "TypeScript",
      "Redux/Redux Toolkit",
      "React Testing Library",
      "Jest",
      "Cypress",
      "Storybook",
      "Webpack",
      "Vite",
      "HTML5",
      "CSS3",
      "Material UI",
    ],
  },
  {
    name: "Backend Development",
    Icon: StorageIcon,
    description: [
      "TypeScript",
      "Node.js",
      "Express",
      "PHP",
      "Java",
      "Spring Boot",
      "C#",
      ".NET Core",
      "Ruby",
      "MySQL",
      "MSSQL",
      "MongoDB",
      "Firebase",
      "RESTful APIs",
    ],
  },
  {
    name: "Mobile Development",
    Icon: SmartphoneIcon,
    description: [
      "Swift",
      "UIKit",
      "SwiftUI",
      "Objective-C",
      "CoreData",
      "XCTest",
      "XCUITest",
      "React Native",
      "Expo",
      "Appium",
    ],
  },
  {
    name: "UI/UX Design",
    Icon: BrushIcon,
    description: [
      "Responsive design",
      "Wireframing",
      "Prototyping",
      "Accessibility",
      "Conversion rate optimization",
      "Multivariate experimentation",
      "User segmentation experimentation",
      "A/B testing",
    ],
  },
  {
    name: "DevOps & Cloud",
    Icon: CloudIcon,
    description: [
      "CI/CD",
      "git",
      "GitHub",
      "GitLab",
      "Jenkins",
      "Artifactory",
      "npm",
      "Docker",
      "Kubernetes",
      "Azure",
      "AWS",
      "GCP",
    ],
  },
  {
    name: "Security",
    Icon: SecurityIcon,
    description: [
      "Secure coding practices",
      "Code review",
      "Reporting",
      "Threat detection",
      "Crash monitoring",
      "Incident remediation",
      "Application-layer security",
      "Apache",
      "Nginx",
      "Proxy management",
      "JWT",
      "OIDC",
      "OAuth 2.0",
      "SSO (Okta)",
    ],
  },
];
